import { motion } from "framer-motion";
import "../style/AllFeaturesSection.css";

const AllFeaturesSection = () => {
    const fadeInUp = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0 }
    };

    const handleNavigate = () => {
        window.location.href = '/features';
    };

    return (
        <section className="all-features-section">
            <div className="container">
                <motion.div
                    className="text-center"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={{
                        visible: {
                            transition: {
                                staggerChildren: 0.15
                            }
                        }
                    }}
                >
                    <motion.h2
                        className="all-features-title"
                        variants={fadeInUp}
                    >
                        Everything You Need - Nothing You Don't
                    </motion.h2>
                    
                    <motion.p
                        className="all-features-subtitle"
                        variants={fadeInUp}
                    >
                        DayDone covers the full job lifecycle, without clutter or complexity.
                    </motion.p>

                    <motion.div
                        variants={fadeInUp}
                    >
                        <button 
                            className="all-features-button"
                            onClick={handleNavigate}
                        >
                            See All Features !
                        </button>
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
};

export default AllFeaturesSection;